<template>
  <section
    v-copy="null"
    class="travel-quote-info">
    <div class="box">
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Insured Period</td>
          <td
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('insurance_period')}">{{ formData.insurance_period}}</td>
        </tr>
        <tr class="tr">
          <td>Expected Insured Period</td>
          <td
            v-copy="formData.period_date"
            :class="{'green-tip':handleCompare('period_date')}">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </td>
        </tr>
        <tr class="tr">
          <td>Total Payable</td>
          <td
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ amount }}</td>
        </tr>
        <tr class="tr">
          <td>Referrer</td>
          <td
            v-if="referrer"
          >
            <referrer-info :referrer="referrer"></referrer-info>
          </td>
        </tr>
        <tr
          v-if="formData.discount_str&&!isFina"
          class="tr">
          <td>Referrer Discount</td>
          <td>{{formData.discount_str}}</td>
        </tr>
        <tr
          v-if="!isEndorse"
          class="tr">
          <td>Policy Number </td>
          <td
            v-copy="formData.pcy_no"
            :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</td>
        </tr>
        <tr
          v-else
          class="tr">
          <td>Endorsement Number </td>
          <td
            v-copy="formData.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</td>
        </tr>
        <tr class="tr">
          <td>Policy Reference Code </td>
          <td
            v-copy="formData.order_sn"
            :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</td>
        </tr>
      </table>
    </div>
    <div
      v-if="excessList.length"
      class="box">
      <h3>Excess</h3>
      <table class="table">
        <tr class="tr th">
          <th>Item</th>
          <th>Amount</th>
        </tr>
        <tr
          v-for="(inItem, index) in excessList"
          :key="index + inItem.premium"
          class="tr">
          <td>{{ inItem.item }}</td>
          <td v-copy="inItem.premium">{{ inItem.premium }}</td>
        </tr>
        <tr class="tr">
          <td>Excess Remark</td>
          <td
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></td>
        </tr>
      </table>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <table
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <tr
            v-if="excessIndex==0"
            class="tr th">
            <th>Item</th>
            <th>Information</th>
          </tr>
          <tr
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <td>{{ subItem.item }}</td>
            <td
              v-copy="subItem.premium"
            >{{ subItem.premium }}</td>
          </tr>
          <tr class="tr">
            <td>Coverage Remark</td>
            <td
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></td>
          </tr>
        </table>
      </div>
    </div>
    <h2>Policy Detail</h2>
    <pet-quote-info
      :formData="formData"
      :preFormData="preFormData"
      :compareList="compareList"></pet-quote-info>

    <div class="box">
      <h3>Remark(s)</h3>
      <table class="table">
        <tr class="tr">
          <td>Remark</td>
          <td
            v-copy="changeLineData(formData.cs_manual_remark)"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import OMath from '@/utils/math'
import PetQuoteInfo from '@/views/components/modules/pet/pet-quote-info'
import ReferrerInfo from '@/views/records/policy/components/info/referrer-info'

export default {
  name: 'PetPolicyDetailInfo',
  components: {PetQuoteInfo,ReferrerInfo},
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    isFina(){
      let {merchant_platform} = this.formData||{}
      return merchant_platform==2
    },
    isShowEmployer(){
      let {occ_id} = this.formData||{}
      return ![220,246].includes(occ_id)
    },
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).add(Number(period_of_cvr)*10, 'months').format('YYYY-MM-DD')
        }
        // return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions27
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage} = quote_coverage_list||{}
      return  coverage
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    }
  },
  methods:{
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
  }
}
</script>
<style lang="scss" scoped>
.housemaid-quote-info{
  .box {
    margin-bottom: 15px;
  }
  .title {
    display: block;
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
}
.asap{
  font-weight: bold;
  color: black;
  margin-left: 5px;
}
</style>
